import { useCallback, useEffect, useState } from "react";
import {
  adminApi,
  AdminScoreSettings,
  AdminScoreSettingsUpdate,
} from "../../../../services/api/admin";

interface UseAdminScoreSettingsReturn {
  settings: AdminScoreSettings | null;
  loading: boolean;
  error: string | null;
  save: (data: AdminScoreSettingsUpdate) => Promise<AdminScoreSettings>;
}

export const useAdminScoreSettings = (
  orgId: string,
): UseAdminScoreSettingsReturn => {
  const [settings, setSettings] = useState<AdminScoreSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await adminApi.getScoreSettings(orgId);
      setSettings(data);
    } catch {
      setError(
        "Wirtschaftlichkeits-Score-Einstellungen konnten nicht geladen werden",
      );
    } finally {
      setLoading(false);
    }
  }, [orgId]);

  useEffect(() => {
    load();
  }, [load]);

  const save = useCallback(
    async (data: AdminScoreSettingsUpdate): Promise<AdminScoreSettings> => {
      const updated = await adminApi.updateScoreSettings(orgId, data);
      setSettings(updated);
      return updated;
    },
    [orgId],
  );

  return { settings, loading, error, save };
};
